import React from "react";
import Button from "./Button";
import { patLogs } from "../context/utils";
import { acknowledgeBlurAlert } from "../utils_new/blurController";

/**
 * The dirty-lens popup, shared by every video module.
 *
 * Raised when every frame of the first ten seconds came back blurry -- see
 * takeBlurWindow in blurController. That check is one-time, so once dismissed
 * this does not come back for the rest of the inspection. Recording is not
 * interrupted.
 *
 * Text comes from config["video-page"] (blurLensHeaderText, blurLensText,
 * blurLensBtnText) when the client sets it, and from the module's own
 * getTranslateText otherwise.
 */
const BlurLensModal = ({ config, getTranslateText, inspectionId, onClose }) => {
  const page = (config && config["video-page"]) || {};
  const text = (key, fallback) =>
    Object.keys(page).includes(key) ? page[key] : getTranslateText(fallback);

  return (
    <div id="blur-lens-modal">
      <div className="blur-lens-card">
        <div className="blur-lens-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 8a2 2 0 012-2h1l1-2h6l1 2h1a2 2 0 012 2v9a2 2 0 01-2 2H6a2 2 0 01-2-2z" />
            <circle cx="12" cy="13" r="3.4" />
            <path d="M19.5 4.5l-15 15" />
          </svg>
        </div>
        <h3 className="blur-lens-title">
          {text("blurLensHeaderText", "We're not getting a clear shot")}
        </h3>
        <p className="blur-lens-text">
          {text(
            "blurLensText",
            "Check that a finger isn't covering the camera, and that the lens is clean. Then continue around the car.",
          )}
        </p>
        <div className="modal-btn-container">
          <Button
            text={text("blurLensBtnText", "Got it")}
            onclick={() => {
              patLogs("blur popup - lens cleaned", inspectionId);
              acknowledgeBlurAlert();
              onClose();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default BlurLensModal;
